import { Injectable } from '@angular/core';
import { PaginationQueryInterface } from '@zaoblako/shared/common/dtos/pagination-query.dto';
import type { PaginationRequiredQueryInterface } from '@zaoblako/shared/common/dtos/pagination-required-query.dto';
import { HistoryPageInterface } from '@zaoblako/shared/common/dtos/history/history-page.dto';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import { DirectoryHistoryServiceInterface } from '@zaoblako/shared/common/interfaces/directory-history-service.interface';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FilialService extends BaseService implements DirectoryHistoryServiceInterface {
  protected baseUrl = '/basis/catalog/filial';

  public history(queryParams: PaginationRequiredQueryInterface): Observable<HistoryPageInterface> {
    return this.http.get<HistoryPageInterface>(`${this.baseUrl}/history`, {
      params: this.objectToHttpParams(queryParams)
    });
  }

  public synchronizeAll(): Observable<null> {
    return this.http.get<null>(`${this.baseUrl}/synchronize`);
  }

  public restore(id: number): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/${id}/restore`, {});
  }

  public getHistoryForOne(id: number, queryParams?: PaginationQueryInterface): Observable<HistoryPageInterface> {
    return this.http.get<HistoryPageInterface>(`${this.baseUrl}/${id}/history`, {
      params: queryParams ? this.objectToHttpParams(queryParams) : {}
    });
  }
}
